module.exports = __webpack_public_path__ + "img/edge_activites_jetski.9eef9a1a.svg";